export const Name = 'centerItemsComponent';
